import "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";

window.addEventListener("load", function () {
  // obtain plugin
  var cc = initCookieConsent();

  // run plugin with your configuration
  cc.run({
    current_lang: navigator.language.split("-")[0] === "de" ? "de" : "en",
    autoclear_cookies: true, // default: false
    // theme_css: "<path-to-cookieconsent.css>",  // 🚨 replace with a valid path
    page_scripts: true, // default: false

    // delay: 0,                               // default: 0
    // auto_language: "",                      // default: null; could also be "browser" or "document"
    // autorun: true,                          // default: true
    // force_consent: false,                   // default: false
    hide_from_bots: true, // default: false
    // remove_cookie_tables: false             // default: false
    // cookie_name: "cc_cookie",               // default: "cc_cookie"
    // cookie_expiration: 182,                 // default: 182 (days)
    // cookie_necessary_only_expiration: 182   // default: disabled
    // cookie_domain: location.hostname,       // default: current domain
    // cookie_path: "/",                       // default: root
    // cookie_same_site: "Lax",                // default: "Lax"
    // use_rfc_cookie: false,                  // default: false
    // revision: 0,                            // default: 0

    onFirstAction: function (userPreferences, cookie) {
      // callback triggered only once on the first accept/reject action
    },

    onAccept: function (cookie) {
      // callback triggered on the first accept/reject action, and after each page load

      if (cc.allowedCategory("analytics")) {
        document
          .querySelectorAll("link[type='text/plain']") // google fonts
          .forEach((tag) => (tag.type = "text/css"));
      }
    },

    onChange: function (cookie, changed_categories) {
      // callback triggered when user changes preferences after consent has already been given
    },

    languages: {
      en: {
        consent_modal: {
          title: "We use cookies!",
          description:
            'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
          primary_btn: {
            text: "Accept all",
            role: "accept_all", // "accept_selected" or "accept_all"
          },
          secondary_btn: {
            text: "Reject all",
            role: "accept_necessary", // "settings" or "accept_necessary"
          },
        },
        settings_modal: {
          title: "Cookie preferences",
          save_settings_btn: "Save settings",
          accept_all_btn: "Accept all",
          reject_all_btn: "Reject all",
          close_btn_label: "Close",
          cookie_table_headers: [
            { col1: "Name" },
            { col2: "Domain" },
            { col3: "Expiration" },
            { col4: "Description" },
          ],
          blocks: [
            {
              title: "Cookie usage 📢",
              description:
                'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="https://aion-returnsportal.s3.eu-central-1.amazonaws.com/store/privacy_policy_8returns.pdf" class="cc-link">privacy policy</a>.',
            },
            {
              title: "Strictly necessary cookies",
              description:
                "These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly",
              toggle: {
                value: "necessary",
                enabled: true,
                readonly: true, // cookie categories with readonly=true are all treated as "necessary cookies"
              },
            },
            {
              title: "Performance and Analytics cookies",
              description:
                "These cookies allow the website to remember the choices you have made in the past",
              toggle: {
                value: "analytics", // your cookie category
                enabled: true,
                readonly: false,
              },
              cookie_table: [
                // list of all expected cookies
                {
                  col1: "^_ga", // match all cookies starting with "_ga"
                  col2: "google.com",
                  col3: "2 years",
                  col4: "description ...",
                  is_regex: true,
                },
                {
                  col1: "_gid",
                  col2: "google.com",
                  col3: "1 day",
                  col4: "description ...",
                },
              ],
            },
            {
              title: "Advertisement and Targeting cookies",
              description:
                "These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you",
              toggle: {
                value: "targeting",
                enabled: false,
                readonly: false,
              },
            },
            {
              title: "More information",
              description:
                'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="mailto:hello@8returns.com">contact us</a>.',
            },
          ],
        },
      },
      de: {
        consent_modal: {
          title: "Wir benutzen Cookies!",
          description:
            'Diese Website verwendet notwendige Cookies, um einen ordnungsgemäßen Betrieb zu gewährleisten, und Tracking-Cookies, um zu verstehen, wie du mit ihr interagierst. Letztere werden nur nach deiner Zustimmung gesetzt. <button type="button" data-cc="c-settings" class="cc-link">Bitte auswählen</button>',
          primary_btn: {
            text: "Alle akzeptieren",
            role: "accept_all", // "accept_selected" or "accept_all"
          },
          secondary_btn: {
            text: "Alle ablehnen",
            role: "accept_necessary", // "settings" or "accept_necessary"
          },
        },
        settings_modal: {
          title: "Cookie-Einstellungen",
          save_settings_btn: "Einstellungen speichern",
          accept_all_btn: "Alle akzeptieren",
          reject_all_btn: "Alle ablehnen",
          close_btn_label: "Close",
          cookie_table_headers: [
            { col1: "Name" },
            { col2: "Domain" },
            { col3: "Gültigkeit" },
            { col4: "Beschreibung" },
          ],
          blocks: [
            {
              title: "Verwendung von Cookies 📢",
              description:
                'Wir verwenden Cookies, um die grundlegenden Funktionen der Website zu gewährleisten und um dein Online-Erlebnis zu verbessern. Du kannst bei jeder Kategorie entscheiden, ob du die Verwendung von Cookies zulassen oder ablehnen möchtest, wann immer du willst. Für weitere Details zu den Cookies und anderen sensiblen Daten lies bitte die vollständige <a href="https://aion-returnsportal.s3.eu-central-1.amazonaws.com/store/privacy_policy_8returns.pdf" class="cc-link">Datenschutzerklärung.</a>.',
            },
            {
              title: "Unbedingt notwendige Cookies",
              description:
                "Diese Cookies sind für das reibungslose Funktionieren dieser Website unerlässlich. Ohne diese Cookies würde die Website nicht richtig funktionieren.",
              toggle: {
                value: "necessary",
                enabled: true,
                readonly: true, // cookie categories with readonly=true are all treated as "necessary cookies"
              },
            },
            {
              title: "Leistungs- und Analyse-Cookies",
              description:
                "Diese Cookies ermöglichen es der Website, sich an die von dir in der Vergangenheit getroffene Auswahl zu erinnern.",
              toggle: {
                value: "analytics", // your cookie category
                enabled: true,
                readonly: false,
              },
              cookie_table: [
                // list of all expected cookies
                {
                  col1: "^_ga", // match all cookies starting with "_ga"
                  col2: "google.com",
                  col3: "2 years",
                  col4: "description ...",
                  is_regex: true,
                },
                {
                  col1: "_gid",
                  col2: "google.com",
                  col3: "1 day",
                  col4: "description ...",
                },
              ],
            },
            {
              title: "Cookies für Werbung und Zielgruppenansprache",
              description:
                "Diese Cookies sammeln Informationen darüber, wie du die Website genutzt, welche Seiten du besucht und auf welche Links du geklickt hast. Alle Daten sind anonymisiert und können nicht dazu verwendet werden, dich zu identifizieren.",
              toggle: {
                value: "targeting",
                enabled: false,
                readonly: false,
              },
            },
            {
              title: "Weitere Informationen",
              description:
                'Wenn du Fragen zu unserer Cookie-Richtlinie und deinen Optionen hast, bitte <a class="cc-link" href="mailto:hello@8returns.com">kontaktiere uns.</a>.',
            },
          ],
        },
      },
    },

    gui_options: {
      consent_modal: {
        layout: "box", // box/cloud/bar
        position: "bottom right", // bottom/middle/top + left/right/center
        transition: "slide", // zoom/slide
        swap_buttons: false, // enable to invert buttons
      },
      settings_modal: {
        layout: "box", // box/bar
        // position: "left",           // left/right
        transition: "slide", // zoom/slide
      },
    },
  });
});
